import React, { useState } from 'react';
import clsx from 'classnames';
import './index.css';
import TweenOne from 'rc-tween-one';

const Detection = () => {
  const [activeItem, setActiveItem] = useState('1');
  const detectionData = [
    {
      title: '安全工器具检测',
      icon: '/images/detectionType1.png',
      iconActive: '/images/detectionTypeActive1.png',
      products:
        '安全帽、安全带、安全绳、绝缘手套、绝缘鞋、绝缘杆、验电器、接地线、绝缘服、绝缘毯、绝缘垫、脚扣、登高板、梯子等。',
      testItems: '预防性试验、抽样试验、型式试验、电气性能试验、机械性能试验。',
      img: '/images/detectionTypeImg1.jpg',
      id: '1',
    },
    {
      title: '电力物资检测',
      icon: '/images/detectionType2.png',
      iconActive: '/images/detectionTypeActive2.png',
      products:
        '主要包括电线电缆、导地线、电力金具、绝缘子、电缆保护管、金属材料、塔材等。',
      testItems: '电气性能试验、机械性能试验、理化性能试验、型式试验。',
      img: '/images/detectionTypeImg2.jpg',
      id: '2',
    },
    {
      title: '电力工具检测',
      icon: '/images/detectionType3.png',
      iconActive: '/images/detectionTypeActive3.png',
      products: '主要包括电钻，磨光机、曲线锯，修枝剪，电动扳手，抛光机等。',
      testItems: '预防性试验、入网检验、电气性能试验。',
      img: '/images/detectionTypeImg3.jpg',
      id: '3',
    },
    {
      title: '工程材料检测',
      icon: '/images/detectionType4.png',
      iconActive: '/images/detectionTypeActive4.png',
      products: '主要包括钢筋、紧固件、地脚螺栓等。',
      testItems: '机械性能试验、理化性能试验、型式试验。',
      img: '/images/detectionTypeImg4.jpg',
      id: '4',
    },
    {
      title: '光伏检测',
      icon: '/images/detectionType5.png',
      iconActive: '/images/detectionTypeActive5.png',
      products:
        '主要包括分布式光伏电站、集中式光伏电站、建筑一体化光伏电站，可进行电能质量、线缆损耗、系统能效、转换效率、功率输出特性等。',
      testItems: '电能质量、线缆损耗、系统能效、转换效率、功率输出特性等。',
      img: '/images/detectionTypeImg5.jpg',
      id: '5',
    },
  ];

  const detectionItem = detectionData.find((item) => item.id === activeItem);
  return (
    <div className={clsx('business-detection')}>
      <div className={clsx('business-detection-mask')} />
      <div className={clsx('business-detection-content')}>
        <div className={clsx('business-detection-content-title')}>检测业务</div>
        <div className={clsx('business-detection-content-desc')}>
          深耕业务深度，优化检测质量
        </div>
        <div className={clsx('business-detection-content-block')}>
          <TweenOne
            className={clsx('business-detection-content-block-left')}
            animation={{ x: -40, opacity: 0, type: 'from' }}
          >
            {detectionData.map((item, index) => (
              <div
                key={index}
                className={clsx('business-detection-content-block-left-item', {
                  detectionTypeActive: activeItem === item.id,
                })}
                onClick={() => setActiveItem(item.id)}
              >
                <img
                  src={activeItem === item.id ? item.iconActive : item.icon}
                  alt={item.title}
                />
                <div
                  className={clsx(
                    'business-detection-content-block-left-item-title',
                  )}
                >
                  {item.title}
                </div>
                <svg
                  viewBox='70 70 916 916'
                  focusable='false'
                  data-icon='right'
                  width='16px'
                  height='16px'
                  fill='currentColor'
                  aria-hidden='true'
                  className={clsx('business-detection-svg')}
                >
                  <path d='M765.7 486.8L314.9 134.7A7.97 7.97 0 00302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 000-50.4z'></path>
                </svg>
              </div>
            ))}
          </TweenOne>
          <TweenOne
            className={clsx('business-detection-content-block-right')}
            animation={{ x: 40, opacity: 0, type: 'from' }}
          >
            {activeItem ? (
              <div
                className={clsx(
                  'business-detection-content-block-right-content',
                )}
                key={activeItem}
              >
                <TweenOne
                  className={clsx(
                    'business-detection-content-block-right-content-title',
                  )}
                  animation={{ y: -60, opacity: 0, type: 'from', delay: 200 }}
                >
                  {detectionItem?.title}
                </TweenOne>
                <TweenOne
                  className={clsx(
                    'business-detection-content-block-right-content-products',
                  )}
                  animation={{ y: -50, opacity: 0, type: 'from', delay: 100 }}
                >
                  检测产品：
                  <br />
                  {detectionItem?.products}
                </TweenOne>
                <TweenOne
                  className={clsx(
                    'business-detection-content-block-right-content-testItems',
                  )}
                  animation={{ y: -30, opacity: 0, type: 'from', delay: 100 }}
                >
                  检测项目：
                  <br />
                  {detectionItem?.testItems}
                </TweenOne>
                <TweenOne
                  animation={{ y: 40, opacity: 0, type: 'from', delay: 200 }}
                >
                  <img
                    src={detectionItem?.img}
                    alt={detectionItem?.title}
                    width={345}
                    height={260}
                    className={clsx(
                      'business-detection-content-block-right-img',
                    )}
                  />
                </TweenOne>
              </div>
            ) : null}
          </TweenOne>
        </div>
      </div>
    </div>
  );
};

export default Detection;
